module.exports = __webpack_public_path__ + "media/images/client/favicons/android-chrome-128x128-090f39c0bb7600f4e73edc082ce3709f.png";